import React, { useEffect, useState, Fragment, useRef } from "react";
import { DivisionReportTableContent } from '../../../Common/Table/tableContent';
import $ from "jquery";
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {

    render() {

        const reportData = this.props.reportData;
        const searchData = this.props.searchData;

        return (
            <div className="pl-2 pr-2">
                <h3><center><u>Integration Details Report</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division == undefined ? 'All' : searchData.division}</div>
                    <div className="col"><b>Transaction Type: </b> {searchData.transactionType == '0' ? 'All' : searchData.transactionType}</div>
                </div>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                </div>
                <div>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>
                                    Emp Reg No
                                </TableCell>
                                <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>
                                    Division
                                </TableCell>
                                <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>
                                    Current
                                </TableCell>
                                <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>
                                    Transaction Type
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                    Date
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                    Status
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                    Created Date & Time
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                    Response Message
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody >
                            {reportData.map((row) => (
                                <TableRow key={row.empNo}>
                                    <TableCell component="th" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.empNo == undefined ? '-' : row.empNo}
                                    </TableCell>
                                    <TableCell component="th" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.collectionPointName == undefined ? '-' : row.collectionPointName}
                                    </TableCell>
                                    <TableCell component="th" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.isCurrent == true ? 'True' : 'False'}
                                    </TableCell>
                                    <TableCell component="th" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.apiTypeName == undefined ? '-' : row.apiTypeName}
                                    </TableCell>
                                    <TableCell component="th" align="left" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {moment(row.date).format("YYYY-MM-DD")}
                                    </TableCell>
                                    <TableCell component="th" align="left" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.status == undefined ? '-' : row.status}
                                    </TableCell>
                                    <TableCell component="th" align="left" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {moment(row.createdDate).format("YYYY-MM-DD HH:mm")}
                                    </TableCell>
                                    <TableCell component="th" align="left" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.responseMessage == undefined ? '-' : row.responseMessage}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>
        );
    }
}
